import { Spin } from "antd";
import { Switch } from "antd";

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import { updatenotificationdata } from "../../../store/Common/CommonSlice";
import "./tablestyle.css";

import {
  CustomeButton,
  LeftHead,
  SubHeadContainer,
  SubHeadTitle,
  TablePagination,
} from "../../../StyledComponents/Common";
import {
  ContentContainer,
  TableTitle,
  TableTop,
} from "../../../StyledComponents/CreateKeyAccountManager";
// import { } from "../../../store/Organization/organizationSlice";
import {
  DeleteCustomerAdmin,
  fetchCustomerAdminList,
} from "../../../store/Customeradmin/cutomeradminslice";
import { MainContainer } from "../../../StyledComponents/Dashboard";
import { Tooltip } from "@mui/material";
import {

  RightSection,
  SpinContainer,
} from "../../../StyledComponents/Queries";
// import { render } from "@testing-library/react";
import CustomerCreateForm from "./CustomerCreateform";
import CustomerUpdateForm from "./CustomerUpdateForm";
// import { use } from "react";
import SimpleTableScroll from "../../Admin/Common/SimpleTableScroll";
import SearchBox from "../../Admin/Common/SearchBox";

import { clearStoredSearch } from "../../../store/Newsearchform/Newsearchform"
import { authuser } from "../../../store/Authentication/AuthSlice";
import { kybstatus } from "../../../store/User/KycSlice";
import { isKybApproved } from "../../../utils/kyb";
let debounceTimer = null;
function CustomeruserTable() {
  const loginedUser = useSelector(authuser);
  const userroles = loginedUser?.userroles||"";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [orgdata, setOrgdata] = useState([]);
  const [pageType, setPageType] = useState("table");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTab, setCurrentTab] = useState("1");
  const [pageSize, setPageSize] = useState(10);
  const [query_instance, setQueryInstance] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(true);
  // Team members can be added once the business verification (KYB) is
  // approved — the backend (createOrgUser) refuses otherwise.
  const kybApproved = isKybApproved(useSelector(kybstatus));
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };



  useEffect(() => {
    setQueryInstance({});

    dispatch(fetchCustomerAdminList(""))
      .then((res) => {
        // console.log("login res => ", res);
        // if(res?.payload?.data?.statusCode === 200 ){
        // console.log(res?.payload.data,"customer table");
        setData(res?.payload?.data);
        //   setFilteredData(res?.payload?.data);
        setLoading(false);

        // }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [pageType]);
  useEffect(() => {
    // dispatch(resetSearchRatesState());
    dispatch(clearStoredSearch());
  }, []);

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleclick = () => {
    // console.log("handleclick")
    setLoading(true);
    setPageType("add_page");
  };
  const handleedit = (record) => {
    // console.log("handleedit")
    setSelectedRow(record);
    setPageType("edit_page");
  };
  const onchange = (record, checked) => {
    console.log(`selected ${checked}`, record);
    const data = {
      user_id: record?._id,
      status: checked ? 1 : 0, // Simplified ternary to send 1 for true, 0 for false
    }
    console.log(data);
    dispatch(DeleteCustomerAdmin(data))
      .then((res) => {
        console.log("login res => ", res);
        dispatch(updatenotificationdata(res?.payload))
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const columns = [
    {
      title: "User Id",
      // dataIndex: 'id',
      dataIndex: "index",
      render: (record, text, index) => {

        return (currentPage - 1) * pageSize + index + 1;
      },
    },
    {
      title: "full name",
      dataIndex: "full_name",
    },

    {
      title: "Email",
      dataIndex: "email",

    },
    {
      title: "Mobile No",
      dataIndex: "phone_number",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Approval Status",
      dataIndex: "approvalStatus",

    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (

        <div className="flex items-center gap-2 justify-center">
          <button
            className="icon_edit"
            onClick={() => handleedit(record)}
          >
            <MdEdit />
          </button>
          <button className="pointer-cursor text-black">
            <Switch
              defaultChecked={record.status === 1 ? true : false}
              className="custom-switch"
              onChange={(checked) => onchange(record, checked)}
            />
          </button>
        </div>
      ),
    },
  ];


  const onSearch = (value) => {
    let queryStringObj = {};
    if (value?.length > 0) {
      queryStringObj["search"] = value;
    }
    let queryString = new URLSearchParams(queryStringObj).toString();
    queryString = queryString ? `?${queryString}` : "";
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      dispatch(fetchCustomerAdminList(queryString)).then(res => {
        setData(res?.payload?.data)
      })
        .catch(err => {
          console.error(err);
        });
    }, 700);
  };

  return (
    <section className="userManagementMain">
    <MainContainer>

      {pageType === "table" ? (
        <>
          {/* <ContentContainer> */}
          {loading ? (
            <SpinContainer className="user-quote">
              <Spin />
            </SpinContainer>
          ) : (
            <ContentContainer>
              <TableTop>
                <TableTitle className="text-xl">User Management </TableTitle>
                <RightSection>
                  <Tooltip
                    title={!kybApproved ? "Complete business verification to add users" : ""}
                    arrow
                    placement="top"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#FEF3E2",
                          color: "#7A4100",
                          border: "1px solid #F5A623",
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "6px",
                          padding: "6px 12px",
                          boxShadow: "0 2px 8px rgba(239,166,3,0.18)",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#F5A623",
                        },
                      },
                    }}
                  >
                    <span>
                      {/* span wrapper needed so Tooltip works on a disabled button */}
                      <button
                        className={`font-bold py-2 px-4 rounded-md text-white text-xs ${kybApproved
                            ? "bg-yellow-500 hover:bg-black hover:text-white cursor-pointer"
                            : "bg-gray-300 text-gray-500 cursor-not-allowed"
                          }`}
                        onClick={kybApproved ? handleclick : undefined}
                        disabled={!kybApproved}
                      >
                        Add Users
                      </button>
                    </span>
                  </Tooltip>
                  {/* add button here  */}
                  <SearchBox onSearch={onSearch} />
                </RightSection>
              </TableTop>

              <SimpleTableScroll
                currentPage={currentPage}
                pageSize={pageSize}
                columns={columns}
                data={data}
              />
            </ContentContainer>
          )}
          {/* </ContentContainer> */}
          {data?.length ? (
            <div className="paginationCustom">
            <TablePagination
              style={{ marginTop: 16, textAlign: "center" }}
              onChange={handlePageChange}
              onShowSizeChange={handlePageSizeChange}
              defaultCurrent={currentPage}
              defaultPageSize={10}
              total={data?.length ? data.length : 10}
              showSizeChanger={false}
              showQuickJumper={false}
            />
            </div>
          ) : null}
        </>
      ) : pageType === "add_page" ? (
        <>
          <ContentContainer>
            {/* <SubHeadContainer className="flex-column"> */}
            <CustomerCreateForm pageType={pageType} setPageType={setPageType} />
            {/* </SubHeadContainer> */}
          </ContentContainer>
        </>
      ) : pageType === "edit_page" ? (
        <>
          <ContentContainer>
            {/* <SubHeadContainer className="flex-column"> */}
            <CustomerUpdateForm
              props={selectedRow}
              pageType={pageType}
              setPageType={setPageType}
            />
            {/* </SubHeadContainer> */}
          </ContentContainer>
        </>
      ) : null}
    </MainContainer>
    </section>
  );
}

export default CustomeruserTable;
